import { environment } from "../environments/environment";

export const urlConfig = Object.freeze({
    production: environment.production,
    url_hub_cms: environment.cmsEndpoint,
    app_key: environment.appKey,
    zup_app_key: environment.zupAppKey,
    bio_elements_url: environment.bioElementsUrl,
    terms_elements_url: environment.termsElementUrl,
    url_api_bff: environment.urlBffApi,
    url_api_identify: environment.urlIdentifyApi,
    url_traking: environment.urlTracking,
    landingUrl: environment.landingUrl,
    landingCMCUrl: environment.landingCMCUrl,
    isStaging: environment.isStaging,
    cmsHeaderStg: environment.cmsHeaderStg,
    showError: environment.showError,
    secret: "LS0tLS1CRUdJTiBQVUJMSUMgS0VZLS0tLS1NSUdmTUEwR0NTcUdTSWIzRFFFQkFRVUFBNEdOQURDQmlRS0JnUURFQllLOE5WK1VReXJ1Q2taTUtLNjVPY09qNXI1TVRBbXB4RUl1Y0tmdGdQdWUwVjRJalV1b2lVSVRiWEFkbFY4QTF2Q05hcjVVQVlOL2NxZk4xK052cUljNys3N2ZYdTZaRmp4LzF2TVpkbVNMdzdwZEJ3aHdaaGZEbnBRdjU3WjlMMGFyUTBEcThOem9hcjM2MWkyeFJLYTF4MHZIRkJubktlc3grQXI3MndJREFRQUItLS0tLUVORCBQVUJMSUMgS0VZLS0tLS0=",
    psecret:
        "LS0tLS1CRUdJTiBQUklWQVRFIEtFWS0tLS0tTUlJQ1d3SUJBQUtCZ1FDT2RXZ043dGlKc3VFamJJZW5lbHhsYVlNWVdMZU1aek1rNWZmYU5yRkRGR2dBSVFhRFJUYUl0b2t0TUZ5YUlVaHR0MEJSaHVxbjg0WUVnOVlmd1JjY0J6Z0R5ZktPT2Q3b1hsV3R1Y1NadkorenFHNGdCcnp2TkVxVjlEWmMzVHhOdHRSanZQNEFhd1VRRTZzcVpjOXhGeXp6c1lvdGNwNHJFOUJuYkFlL2N3SURBUUFCQW9HQU5tQWIrbzE3TzN2NnNXSEFtYTE3elAyc0cwUHBzMzdFcDhYYmlBQXVRdk5zQ3ZpUUd0VDFUdE9Wb3BqK0Q1cTZvWjQ3djZLbXVMcWNJZWNNZVF4anZDMzh2U0R4Q290U2dHV3B5VEVsOThENC9vMWZRencyZHhOUmdhWlJlbmlWTWsrUG81TXUyUGNGbmY5ZWwzRFF4V1JhcE40UWVxUm83RENXY0syR2Z4a0NRUURLeWs1a2hseEVPajdYV0Y0dE1OVEEzU3lZVk9UaFNPNThvbU9UTlZvdmNub3NDVTFuMGlqbTVSdjRqb2pzYzR3czRrNmJmYWFXUlNaSU5HLzZzeUpmQWtFQXM5YUxCV0xvZDJzVzRuZlUvVFdlZEJ6V0JncGl2eGplQ1gzQjNxSXM2ZExYN0x0YlBUV2Z1UEl3QVR3UGxoS3dkSVVieitjTERYbUdpNVJyNTRVRGJRSS9VTXhLYjhNWkFCWTA4NWhCN2IrSEJWRWFjNWRmbW1OMG9qUVJlSlhKV1I1RGowZ2xqemd0RTlJMVV0TjN1cjVQRzVNUHZ1UlJlNDRSc3JNeDZyRjFBa0VBbkQ2YS9Dd0p3cThFNisrbTJmTjYzbkNyTmdaUjhxdDlSWXZBSTFpTll2MHZZbHNKRXk0Q3ZpR1V1WTNnRU1mZURPNFUwdFZ1VWQreW1KUjBCMnNXSlFKQVlpTTRqcmNpS0dhUEVaZi8zdnkvcmNkMjVFd3R2alI4ajFPRWFnVGQ0WWxqUzFLaGx1K051Z2Z5dXk4RlVFVGIzdW1HRVFHMlYwaHQ2dDZia09GcUlBPT0tLS0tLUVORCBQUklWQVRFIEtFWS0tLS0t",
    storeLinks: {
        android:
            "https://play.google.com/store/apps/details?id=com.santander.app&hl=pt_BR",
        ios: "https://apps.apple.com/br/app/santander-brasil/id613365711",
        desktop:
            "https://www.santander.com.br/atendimento-para-voce/app-santander?ic=digitalizacao",
    },
    flag_hotjar: environment.flag_hotjar,
    flag_anti_flicker: environment.flag_anti_flicker,
    key_anti_flicker: environment.key_anti_flicker,
    flag_optimize: environment.flag_optimize,
    key_optimize: environment.key_optimize,
    flag_google_analytics: environment.flag_google_analytics,
    flag_edit_name: environment.flag_edit_name,
    key_google_analytics: environment.key_google_analytics,
    id_google_tag_manager: environment.id_google_tag_manager,
    url_offer_package: environment.offerPackage.mainPath,
    url_offer_overdraft: environment.base.url_overdraft_element,
    base: {
        urlHub:environment.base.url_hub,
        urlCaptchaElement: environment.base.url_captcha_element,
        urlCrypto: environment.base.url_crypto,
        urlApigee: environment.base.url_apigee,
        urlApiBff: environment.base.url_api_bff,
        urlCaptcha: environment.base.url_captcha,
    },
    auth: {
        urlLogin: environment.auth.url_login,
        urlLogout: environment.auth.url_logout,
        cliendId: environment.auth.cliendId,
        ApigeeAppKey: environment.auth.apigee_app_key,
        zupAppKey: environment.auth.zup_app_key,
    },
    paths: {
        captcha: environment.paths.captcha,
    },
    enableCaptcha: environment.enableCaptcha,
    path_captcha:environment.path_captcha,
    keys:{
        captcha:{
          visible:environment.keys.captcha.visible,
          invisible:environment.keys.captcha.invisible,
          sytemCode:environment.keys.captcha.sytemCode,
          captchaKey: environment.keys.captcha.captchaKey
        }
    },
    dlb_crypt: environment.dlb_crypt,
    biometry: {
        url_documents_element: environment.biometry.url_biometry_element
    },
    document: {
        url_document_element: environment.document.url_document_element
    },
    clearSale:{
        appKey: environment.clearSale.appKey,
        fcpMonitor: environment.clearSale.fcpMonitor,
        fpCheckUrl: environment.clearSale.fpCheckUrl,
        fpImgTag: environment.clearSale.fpImgTag,
        fpJs: environment.clearSale.fpJs,
      }
});

